//处理Template返回数据
export const handleAsyncTemplateData = (data = [], intentList = []) => {
  const templateListFrontend = data.map((x) => {
    return {
      id: x.id,
      intent_label: intentList.find((y) => y.value == x.intent)?.label,
      intent: x.intent,
      tag: x.custom_tag,
      tag_to_zd: x.enable_add_custom_tag,
      auto_reply: x.enable_auto_reply,
      confidence_score: x.confidence_score,
      template_status: x.is_active,
      message: x.template_content,
    };
  });

  const templateListBackend = data.map((x) => {
    return {
      id: x.id,
      intent: x.intent,
      intent_label: intentList.find((y) => y.value == x.intent)?.label,
      tag: x.custom_tag,
      tag_to_zd: x.enable_add_custom_tag,
      auto_reply: x.enable_auto_reply,
      confidence_score: x.confidence_score,
      template_status: x.is_active,
      message: x.template_content,
    };
  });

  console.log({
    frontend: templateListFrontend,
    backend: templateListBackend,
  });

  return {
    frontend: templateListFrontend,
    backend: templateListBackend,
  };
};

// operation history table类型 数据处理
// export const handleOperationHistoryData = (data = []) => {
//   const operationHistoryList = data.map((x, index) => {
//     let returnObj = {
//       id: index,
//       date: x.update_time,
//       user: x.user_name,
//       change: x.item,
//       from: x.oldValue,
//       to: x.newValue,
//     };
//
//     if (x.item == "newTemplate") {
//       returnObj.change = "new template created";
//
//     } else if (x.item == "intent") {
//         returnObj.change = "Intent";
//
//     } else if (x.item == "cs_status") {
//       returnObj.change = "Order Status";
//
//     } else if (x.item == "store_code") {
//       returnObj.change = "Store";
//
//     } else if (x.item == "condition") {
//       returnObj.change = "Condition";
//
//     } else if (x.item == "recipient") {
//       returnObj.change = "Recipient";
//
//     } else if (x.item == "auto_reply") {
//       returnObj.change = "Auto reply";
//       returnObj.from = (x.oldValue == 1) ? "Yes" : "No";
//       returnObj.to = (x.newValue == 1) ? "Yes" : "No";
//
//     } else if (x.item == "name") {
//       returnObj.change = "Template name";
//
//     } else if (x.item == "message") {
//       returnObj.change = "Template content";
//       returnObj.from = "";
//       returnObj.to = "";
//
//     } else if (x.item == "active") {
//       returnObj.change = "Is active";
//       returnObj.from = (x.oldValue == 1) ? "Yes" : "No";
//       returnObj.to = (x.newValue == 1) ? "Yes" : "No";
//
//     } else if (x.item == "draft") {
//       returnObj.change = "Is draft";
//       returnObj.from = (x.oldValue == 1) ? "Yes" : "No";
//       returnObj.to = (x.newValue == 1) ? "Yes" : "No";
//
//     } else if (x.item == "variation") {
//       returnObj.change = "Variation";
//     }
//
//     return returnObj;
//   });
//   return operationHistoryList;
// };
